import { render, staticRenderFns } from "./CollectionGroup.vue?vue&type=template&id=2c574eee"
import script from "./CollectionGroup.vue?vue&type=script&lang=js"
export * from "./CollectionGroup.vue?vue&type=script&lang=js"
import style0 from "./CollectionGroup.vue?vue&type=style&index=0&id=2c574eee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports